<template>
    <div id="Stepper">
        <div class="stepper-container">
            <div
                :class="activeIndex === index ? 'step active' : 'step'"
                :key="index"
                v-for="(step, index) in steps"
                @click="stepClickHandler(index)"
            >
                <div v-if="index !== 0 && steps.length !== index" class="arrow">
                    <DynamicSvg :name="'Arrow'" />
                </div>
                <div class="content">
                    <div class="circle">
                        <div class="icon-container">
                            <DynamicSvg :color="activeIndex === index ? '#EC4B1D' : '#333'" :name="step.iconName" />
                        </div>
                    </div>
                    <div class="title">
                        {{ step.title }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DynamicSvg from "../common/DynamicSvg.vue";

export default {
    name: "Stepper",
    components: { DynamicSvg },
    props: {
        steps: {
            type: Array,
            required: true,
            title: String,
            iconName: String,
        },
        goNextPage: { type: Number },
    },
    data() {
        return {
            activeIndex: 0,
        };
    },
    methods: {
        stepClickHandler(stepIndex) {
            this.activeIndex = stepIndex;
            this.$emit("changeStep", this.activeIndex);
        },
    },
    watch: {
        goNextPage() {
            this.activeIndex = this.goNextPage;
        },
    },
};
</script>

<style scoped lang="scss">
#Stepper {
    padding-top: 20px;

    .stepper-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 90%;
        margin: 0 auto;
        margin-top: 20px;

        .step {
            display: flex;
            align-items: center;
            position: relative;
            cursor: pointer;
            user-select: none;

            .arrow {
                position: absolute;
                top: calc(50% - 7px);
                left: -100px;
            }

            .content {
                text-align: center;

                .circle {
                    border: 2px solid #dddfe1;
                    border-radius: 50%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 70px;
                    height: 70px;
                    margin: 0 auto;
                    margin-bottom: 15px;

                    .icon-container {
                        width: 50px;
                        margin: 0;
                        padding: 0;

                        svg {
                        }

                        path {
                        }
                    }
                }

                .title {
                    font-size: 20px;
                    font-weight: normal;
                    line-height: 24px;
                    font-style: normal;
                    text-align: center;
                    color: #333333;
                }
            }

            &.active {
                .content {
                    .circle {
                        border: 2px solid #ec4b1d;
                    }
                }
            }
        }
    }
}

@media (max-width: 600px) {
    #Stepper {
        display: none;
    }
}
</style>
